import React from 'react';
import Button from '@atoms/Button/Button';
import Section from '@atoms/Section/Section';
import DialogContent from './DialogContent';
import DialogFooter from './DialogFooter';
import DialogFullHeader from './DialogFullHeader';

interface Props {
    children: React.ReactNode;
    title?: string;
    hideModal: VoidFunction;
    mainButton?: any;
    secondaryButton?: any;
}

const ActionDialog: React.FC<Props> = ({
    children,
    title,
    hideModal,
    mainButton,
    secondaryButton,
}) => {
    return (
        <>
            {title && (
                <DialogFullHeader
                    title={title}
                    onCloseButtonClick={hideModal}
                />
            )}
            <DialogContent>{children}</DialogContent>
            <DialogFooter>
                <Section>{mainButton && <Button {...mainButton} />}</Section>
                {secondaryButton && (
                    <Button variant="naked" {...secondaryButton} />
                )}
            </DialogFooter>
        </>
    );
};

export default ActionDialog;
